<template>
  <div>
    <div class="row" v-if="!$route.params.id">
      <b-container fluid class='no-paddings'>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col md="6">
            <b-input-group prepend="Per page">
              <b-form-select :options="page_options" v-model="per_page" placeholder="5" />
            </b-input-group>
          </b-col>
        </b-row>
      </b-container>
      <div class="col-sm-12">
        <b-table striped hover :filter='filter' @filtered='onFiltered' :items="clients" :fields="tableFields" :current-page="currentPage" :per-page="per_page">
          <template slot="name" slot-scope="data">
            <router-link :to="{name: 'Client', params: { id: data.item.external_client_id } }">{{data.item.name}}</router-link>
          </template>
        </b-table>
        <b-pagination :per_page="per_page" v-model="currentPage" :total-rows="total_clients"></b-pagination>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <router-view/>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'AdminClients',
  components: {
  },
  data () {
    return {
      clients: [],
      total_clients: 150,
      currentPage: 1,
      per_page: 25,
      page_options: [5, 10, 25, 100, 1000],
      filter: null
    }
  },
  created () {
    this.getClients()
    this.loadFields()
  },
  watch: {
  },
  methods: {
    ...mapActions(['loadFields']),
    getClients () {
      var vm = this
      this.$http.get('/clients')
        .then(function (response) {
          vm.clients = response.data.clients
          vm.total_clients = response.data.total_clients
        })
        .catch(e => { console.log(e.response) })
    },
    onFiltered (filteredItems) {
      this.total_clients = filteredItems.length
      this.currentPage = 1
    }
  },
  computed: {
    ...mapGetters(['fields', 'currentUser']),
    tableFields () {
      let fieldsArray = ['name', 'address', 'active']
      let customFields = this.fields.filter(field => this.currentUser.fields_order.includes(field.name))
      customFields = customFields.map(field => `custom_fields.${field.name}`)
      fieldsArray = fieldsArray.concat(customFields, ['actions'])
      fieldsArray = fieldsArray.map(field => {
        let a = {[field]: {
          sortable: (field !== 'actions')
        }}
        return a
      })
      return fieldsArray
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Clients.vue